import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { environment } from '@/helpers/Environment';
import { csvToArray, stripWhitespace } from '@/helpers/StringHelpers';
import FormInput2 from '@/components/forms/FormInput2.vue';
const invalidCitypassCodeMessage = 'Does not match the expected format. Please check your CityPASS code.';
@Component({
    name: 'CitypassCoupons',
    components: { FormInput2 },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    ticketGroups;
    @Prop({ required: true })
    quantities;
    @Prop({ required: true })
    error;
    @Prop()
    submitting;
    // Checkbox state.
    checkboxChecked = false;
    // User-input state.
    internal = {};
    errors = {};
    t;
    opt;
    validate(_, inputEl, pattern, key) {
        Vue.delete(this.errors, key);
        // Let built-in validation handle empty values.
        if (inputEl.value.length === 0)
            return;
        const code = stripWhitespace(inputEl.value);
        if (!code.match(new RegExp(pattern))) {
            Vue.set(this.errors, key, invalidCitypassCodeMessage);
        }
    }
    @Watch('checkboxChecked')
    @Watch('quantities', { deep: true })
    @Watch('internal', { deep: true })
    @Emit('input')
    emitCouponCodes() {
        // Only return coupon codes for the current selection of ticket types and quantities,
        // even if there are more stored in this.internal from earlier.
        return this.currentKeys.map((key) => {
            const value = this.internal[key];
            if (value) {
                return stripWhitespace(value);
            }
        });
    }
    /**
     * Keys for all tickets that require a CityPASS coupon based on current selection of ticket types and quantities.
     */
    get currentKeys() {
        const result = [];
        if (this.checkboxChecked) {
            for (const group of this.couponFieldGroups) {
                result.push(...group.keys);
            }
        }
        return result;
    }
    get couponFieldGroups() {
        const result = [];
        for (const group of this.ticketGroups) {
            for (const type of group.types) {
                const quantity = this.quantities[type.id]?.quantity;
                if (quantity) {
                    result.push(this.getCouponFieldGroup(type, quantity));
                }
            }
        }
        return result;
    }
    /**
     * Collects config and generates keys for coupon fields for a ticket type.
     */
    getCouponFieldGroup({ id, name, description }, quantity) {
        const keys = [];
        for (let index = 0; index < quantity; index++) {
            keys.push(`${id}.${index}`);
        }
        const config = environment.config.citypass_code_groups;
        const pattern = this.isChildTicket(name) ? config.child_regexp : config.adult_regexp;
        return { id, name, description, keys, pattern };
    }
    /**
     * Determines if child CityPASS coupons should be used for a ticket type.
     */
    isChildTicket(ticketTypeName) {
        const name = ticketTypeName.toLowerCase();
        return this.childKeywords.some((keyword) => name.includes(keyword));
    }
    get childKeywords() {
        const config = environment.config.citypass_code_groups?.child_ticket_type_keywords;
        if (config != undefined)
            return config.map((item) => item.toLowerCase());
        // TODO Move config in tenants/*/config.yml to CMS and remove this.
        if (this.opt.childKeywords)
            return csvToArray(this.opt.childKeywords);
        return ['child'];
    }
}
